import { StepAnalyseEnum } from './analyse-credit';
import { BaseModel } from './base-model';

export class Indicator extends BaseModel {
  public id: string;
  public valorRecEntradaVenda: Number;
  public valorRecCustoProduto: Number;
  public valorLimiteCompometido: Number;
  public valorLimiteMargem: Number;
  public prazoVendaFatur: Number;
  public tempoEstoque: Number;
  public daysToValidity: Number;
  public caixaComprometido: Number;
  public parecerIndicativo: Array<ParecerIndicativo>;
  public powersStep: Array<PowersStep>;
  public daysHistoryCustomer: number;

	constructor() {
		super();
		this.id = null;
		this.valorRecEntradaVenda = null;
		this.valorRecCustoProduto = null;
		this.valorLimiteCompometido = null;
		this.valorLimiteMargem = null;
		this.prazoVendaFatur = null;
		this.tempoEstoque = null;
		this.daysToValidity = null;
		this.caixaComprometido = null;
		this.parecerIndicativo = new Array<ParecerIndicativo>();
		this.powersStep = new Array<PowersStep>();
		this.daysHistoryCustomer = null;
	}

}

export class ParecerIndicativo {
  public description: string;
  public valueStart: Number;
  public valueEnd: Number;
  public color: string;

  constructor() {
    this.description = null;
    this.valueStart = null;
    this.valueEnd = null;
    this.color = null;
  }
}

export class PowersStep {
  public step: StepAnalyseEnum;
  public value: number;
  public acceptance: number;

  constructor() {
    this.step = null;
    this.value = null;
    this.acceptance = null;
  }
}
